<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      padding: 10px;
    "
  >
    <div class="infoBox">
      <ul style="position: relative">
        <el-button
          type="primary"
          :icon="Edit"
          link
          @click="state.showCompile = true"
          style="position: absolute; top: 0; right: 0"
          >编辑
        </el-button>
        <li>
          <div class="title">
            <li>状态</li>
            ：
          </div>
          <div class="content">
            <text style="color: #1779de" v-if="state.model.IsQy">启用</text
            ><text style="color: #f00" v-else>停售</text>
          </div>
        </li>
        <li>
          <div class="title">
            <li>品类</li>
            ：
          </div>
          <div class="content">
            {{ state.model.PlMc }}
          </div>
        </li>
        <li>
          <div class="title">
            <li>供应商</li>
            ：
          </div>
          <div class="content" style="padding-right: 50px">
            {{ state.model.GysMc }}
          </div>
        </li>
      </ul>
      <ul>
        <li>
          <div class="title">
            <li>商品名称</li>
            ：
          </div>
          <div class="content">
            {{ state.model.Mc }}
          </div>
        </li>
        <li>
          <div class="title">
            <li>联系电话</li>
            ：
          </div>
          <div>
            {{ state.model.Dh || "-" }}
          </div>
        </li>
        <li>
          <div class="title">
            <li>地址</li>
            ：
          </div>
          <div class="content">
            {{ state.model.Dz || "-" }}
          </div>
        </li>
        <li>
          <div class="title">
            <li>预约设置</li>
            ：
          </div>
          <div class="content">
            <text v-if="state.model.IsYuyue" style="color: #1779de">
              需要预约（提前{{ state.model.YuyueTianShu }}天）
            </text>
            <text v-else style="color: #999">无需预约</text>
          </div>
        </li>
      </ul>
      <ul>
        <div class="title">
          <li>商品简介</li>
          ：
        </div>
        <div class="content">
          {{ state.model.Jj }}
        </div>
      </ul>
    </div>
    <el-tabs
      v-model="state.tabName"
      :before-leave="onTabsChange"
      class="comTab detailTab"
      style="position: inherit"
    >
      <el-tab-pane label="商品详情" name="xq">
        <el-form
          :model="state.model"
          label-width="100px"
          :scroll-to-error="true"
          ref="formDom"
          inline
          style="position: relative"
        >
          <el-form-item
            label="目的地"
            prop="Mdds"
            :rules="[
              { required: true, message: '请选择目的地', trigger: 'blur' },
            ]"
            style="width: 100%"
          >
            <el-select
              v-model="state.model.Mdds"
              multiple
              placeholder="--请选择目的地--"
              :filter-method="onMddFilter"
              :disabled="!Array.isArray(state.mddData)"
            >
              <el-option
                v-for="item in state.mddData"
                :key="item"
                :label="item.Mc"
                :value="item.Mc"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="商品图片"
            prop="Tps"
            :rules="[
              { required: true, message: '请选择上传图片', trigger: 'blur' },
            ]"
            style="width: 99%; display: flex; align-items: center"
          >
            <el-radio-group
              v-model="state.model.Fm"
              style="display: flex; line-height: normal"
            >
              <div
                v-for="(tp, index) in state.model.Tps"
                :key="tp"
                style="
                  margin-right: 10px;
                  border-radius: 5px;
                  overflow: hidden;
                  position: relative;
                "
                class="uploadTpBox"
              >
                <el-image class="uploadTp" :src="$http.defaults.baseURL + tp" />
                <ul style="text-align: center">
                  <el-radio :label="tp" size="small">设为封面</el-radio>
                </ul>
                <div class="uploadDel">
                  <el-icon
                    size="30"
                    style="margin: auto; cursor: pointer"
                    @click="onDelTp(index)"
                    ><Delete
                  /></el-icon>
                </div>
              </div>
            </el-radio-group>
            <el-upload
              :show-file-list="false"
              :auto-upload="false"
              :multiple="true"
              accept=".jpeg,.jpg,.png,.gif"
              :on-change="onUploadChange"
              :on-exceed="onUploadExceed"
            >
              <template #trigger>
                <div class="uploadAdd">
                  <el-icon size="30" style="margin: auto; cursor: pointer"
                    ><Plus
                  /></el-icon>
                </div>
              </template>
            </el-upload>

            <!-- <el-upload
              :action="$http.defaults.baseURL + '/Home/Upload'"
              :show-file-list="false"
              :on-success="onUploadSuccess"
              name="file"
              :headers="{
                Authorization: state.token,
              }"
              class="proUpload"
            >
              <el-radio-group v-model="state.model.Fm" style="display: flex">
                <div
                  v-for="(item, index) in state.model?.Tps"
                  :key="item"
                  class="proUpBox"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="$http.defaults.baseURL + '/' + item"
                  />
                  <el-radio :label="item" size="small">设为封面</el-radio>
                  <div class="proUpShade">
                    <el-icon
                      color="#fff"
                      size="30"
                      style="margin: auto; cursor: pointer"
                      @click="onDelTp(item, index)"
                      ><Delete
                    /></el-icon>
                  </div>
                </div>
              </el-radio-group>
              <template #trigger>
                <el-icon
                  class="addPic"
                  size="30"
                  :style="{
                    'margin-bottom': state.model?.Tps?.length > 0 ? '28px' : '',
                  }"
                >
                  <Plus />
                </el-icon>
              </template>
            </el-upload> -->

            <!-- <el-upload
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-change="onUploadChange"
              multiple
              ref="uploadDom"
              v-model:file-list="state.model.Tps"
            >
              <el-icon><Plus /></el-icon>
              <template #file="{ file }">
                <el-radio-group
                  v-model="state.model.Fm"
                  style="align-items: normal; flex-wrap: nowrap"
                >
                  <div style="display: flex; flex-direction: column">
                    <ul style="flex: 1; overflow: hidden; position: relative">
                      <el-image
                        class="el-upload-list__item-thumbnail"
                        :src="
                          file.url.includes('/image/product')
                            ? $http.defaults.baseURL + file.url
                            : file.url
                        "
                        style="width: 100%"
                      />
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="onHandlePreview(file)"
                        >
                          <el-icon><zoom-in /></el-icon>
                        </span>
                        <span
                          class="el-upload-list__item-delete"
                          @click="onHandleRemove(file)"
                        >
                          <el-icon><Delete /></el-icon>
                        </span>
                      </span>
                    </ul>
                    <ul style="text-align: center">
                      <el-radio :label="file?.uid">设为封面</el-radio>
                    </ul>
                  </div>
                </el-radio-group>
              </template>
            </el-upload> -->
            <el-dialog v-model="state.dialogVisible">
              <el-image fit="cover" :src="state.dialogImageUrl" />
            </el-dialog>
          </el-form-item>
          <el-form-item label="商品详情" style="width: 99%">
            <c_editor :value="state.model.Xq" ref="editorDom"></c_editor>
          </el-form-item>
          <el-form-item label="&nbsp;" style="width: 100%">
            <el-button type="primary" @click="onSubmit()">提交</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="预定须知" name="xz">
        <el-input
          type="textarea"
          v-model="state.model.Xz"
          :autosize="{ minRows: 10 }"
          placeholder="预定须知"
        />
        <el-button type="primary" @click="onSubmit()" style="margin-top: 10px">
          提交
        </el-button>
      </el-tab-pane>
      <el-tab-pane label="价格套餐" name="tc">
        <c_ShangPinTcList
          :spId="props.data?.id"
          :key="state.tcKey"
          @onLoad="onLoadTc"
        ></c_ShangPinTcList>
      </el-tab-pane>
      <el-tab-pane name="gz">
        <template #label>
          <text :style="{ color: state.tcData?.length > 0 ? '' : '#a2a2a2' }">
            销售控制
          </text>
        </template>
        <c_ShangPinGzList
          :spId="props.data?.id"
          :key="state.gzKey"
        ></c_ShangPinGzList>
      </el-tab-pane>
      <el-tab-pane name="lsgz">
        <template #label>
          <text :style="{ color: state.tcData?.length > 0 ? '' : '#a2a2a2' }">
            历史销控
          </text>
        </template>
        <c_ShangPinGzOldList
          :spId="props.data?.id"
          :key="state.lsgzKey"
        ></c_ShangPinGzOldList>
      </el-tab-pane>
      <el-tab-pane label="关联订单" name="dd">
        <c_ShangPinDdList
          :spId="props.data?.id"
          :key="state.ddKey"
        ></c_ShangPinDdList>
      </el-tab-pane>
      <el-tab-pane lazy label="评价信息" name="pingjia">
        <div class="pjWrap">
          <!-- 评价统计概览 -->
          <div class="pjSummary" v-if="state.pjSummary.totalCount > 0">
            <div class="pjScoreBox">
              <span class="pjScore">{{ state.pjSummary.avgRating }}</span>
              <span class="pjUnit">/5</span>
              <div class="pjStars">
                <el-rate
                  v-model="state.pjSummary.avgRating"
                  disabled
                  show-score
                  text-color="#ff9900"
                />
              </div>
              <span class="pjTotal"
                >共 {{ state.pjSummary.totalCount }} 条评价</span
              >
            </div>
            <div class="pjDist">
              <div class="pjDistItem" v-for="i in 5" :key="i">
                <span class="pjDistLabel">{{ 6 - i }}星</span>
                <el-progress
                  :percentage="getRatingPercent(6 - i)"
                  :show-text="false"
                  :stroke-width="8"
                  color="#f5a623"
                />
                <span class="pjDistCount">{{ getRatingCount(6 - i) }}</span>
              </div>
            </div>
          </div>

          <!-- 评价列表 -->
          <div class="pjList">
            <div class="pjItem" v-for="pj in pagedPjList" :key="pj.Id">
              <div class="pjHeader">
                <span class="pjUser">{{ pj.CjrXm }}</span>
                <el-rate v-model="pj.Xj" disabled size="small" />
                <span class="pjTime">{{ formatTime(pj.Cjsj) }}</span>
              </div>
              <div class="pjTags" v-if="pj.PjBq">
                <el-tag
                  v-for="tag in pj.PjBq.split(',')"
                  :key="tag"
                  size="small"
                  type="info"
                  style="margin-right: 6px"
                  >{{ tag }}</el-tag
                >
              </div>
              <div class="pjContent">{{ pj.PjNr }}</div>
              <div class="pjImages" v-if="pj.PjTp">
                <el-image
                  v-for="(img, idx) in pj.PjTp.split(',')"
                  :key="idx"
                  :src="$http.defaults.baseURL + img"
                  :preview-src-list="
                    pj.PjTp.split(',').map((u) => $http.defaults.baseURL + u)
                  "
                  :initial-index="idx"
                  fit="cover"
                  class="pjImg"
                />
              </div>
              <!-- 商家回复 -->
              <div class="pjReply" v-if="pj.HfNr">
                <div class="pjReplyHeader">
                  <span class="pjReplyLabel">商家回复</span>
                  <span class="pjReplyTime">{{ formatTime(pj.HfSj) }}</span>
                </div>
                <div class="pjReplyContent">{{ pj.HfNr }}</div>
              </div>
            </div>

            <!-- 分页 -->
            <div
              class="pjPagination"
              v-if="state.pjList.length > state.pjPageSize"
            >
              <el-pagination
                v-model:current-page="state.pjPageIndex"
                :page-size="state.pjPageSize"
                :total="state.pjList.length"
                layout="total, prev, pager, next"
                background
                small
              />
            </div>

            <!-- 暂无评价 -->
            <div
              class="pjEmpty"
              v-if="state.pjLoaded && state.pjList.length === 0"
            >
              <el-empty description="暂无评价信息" />
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCompile"
        title="修改商品"
        @close="state.showCompile = false"
      >
        <c_Compile
          @close="
            state.showCompile = false;
            onLoadDetail();
          "
          :id="props.data?.id"
        ></c_Compile>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref, computed } from "vue";
import {
  zidian_select,
  shangpin_detail,
  shangpintaocan_all,
  shangpin_edit,
  shangpin_uploadtp,
  shangpinpingjia_getbyspid,
  shangpinpingjia_getsummary,
} from "@/http/api";
import { ElMessage } from "element-plus";

import c_Compile from "./Compile.vue";
export default {
  props: {
    data: Object,
  },
  name: "SheZhi",
  components: { c_Compile },
  setup(props) {
    const editorDom = ref(null);
    const formDom = ref(null);
    const uploadDom = ref(null);
    const state = reactive({
      tabName: "xq",
      model: {
        Tps: [],
        Mdds: [],
      },
      pics: [],
      tcData: [],
      delPics: [], //删除的图片地址
      pjList: [],
      pjLoaded: false,
      pjPageIndex: 1,
      pjPageSize: 5,
      pjSummary: {
        totalCount: 0,
        avgRating: 0,
        ratingDistribution: { one: 0, two: 0, three: 0, four: 0, five: 0 },
      },
    });
    //分页后的评价列表
    const pagedPjList = computed(() => {
      const start = (state.pjPageIndex - 1) * state.pjPageSize;
      return state.pjList.slice(start, start + state.pjPageSize);
    });

    onMounted(() => {
      if (props.data?.id) {
        onLoadDetail();
      }
      loadMdd();
      onLoadTc();
    });

    const onLoadDetail = () => {
      state.pics = [];
      state.delPics = [];
      shangpin_detail(props.data?.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data;
          if (state.model.Fm) {
            state.model.Tps = [state.model.Fm, ...state.model.Tps];
          }
        }
      });
    };

    //加载品类下拉数据
    const loadMdd = () => {
      zidian_select("目的地").then((res) => {
        if (res.status == 200) {
          state.mddData = res.data;
          state.mddSource = res.data;
        }
      });
    };

    //下拉框自定义筛选
    const onMddFilter = (query) => {
      state.mddData = state.mddSource.filter(
        (w) =>
          w.Py?.toUpperCase().includes(query.toUpperCase()) ||
          w.Sp?.toUpperCase().includes(query.toUpperCase()) ||
          w.Mc?.includes(query.toUpperCase())
      );
    };

    //加载套餐数据
    const onLoadTc = () => {
      shangpintaocan_all(props.data?.id).then((res) => {
        if (res.status == 200) {
          state.tcData = res.data;
        }
      });
    };

    //选项卡切换事件
    const onTabsChange = (value) => {
      if (value == "tc") {
        state.tcKey = Math.random();
      } else if (value == "gz") {
        if (state.tcData?.length <= 0) {
          ElMessage({
            type: "warning",
            message: "请先添加商品套餐！",
            grouping: true,
          });
          return false;
        }
        state.gzKey = Math.random();
      } else if (value == "lsgz") {
        state.lsgzKey = Math.random();
      } else if (value == "dd") {
        state.ddKey = Math.random();
      } else if (value == "pingjia") {
        state.pjPageIndex = 1;
        loadPingJia();
      }
    };

    //选择文件
    const onUploadChange = (file) => {
      let formData = new FormData();
      formData.append("files", file.raw);
      shangpin_uploadtp(formData).then((res) => {
        console.log(res.data);
        if (res.status == 200) {
          state.model.Tps = [...state.model.Tps, ...res.data];
          if (!state.model.Fm) state.model.Fm = state.model.Tps[0];
        }
      });
      // state.pics.push(file.raw);
      // if (!state.model.Fm) state.model.Fm = file.uid;
    };

    //图片预览
    const onHandlePreview = (file) => {
      state.dialogImageUrl = file.url;
      state.dialogVisible = true;
    };

    //删除图片
    const onHandleRemove = (file) => {
      uploadDom.value.handleRemove(file);
      state.pics.splice(state.pics.indexOf(file.raw), 1);
      if (file.url.includes("image/product")) state.delPics.push(file.url);
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        state.model.Mdd = state.model.Mdds.join("、");
        state.model.Xq = editorDom.value?.state?.value;

        // let formData = new FormData();
        // //把接口需要的参数带进去
        // formData.append("Id", state.model.Id);
        // formData.append("IsQy", state.model.IsQy);
        // formData.append("PlId", state.model.PlId);
        // formData.append("GysId", state.model.GysId);
        // formData.append("Mc", state.model.Mc || "");
        // formData.append("Dh", state.model.Dh || "");
        // formData.append("Dz", state.model.Dz || "");
        // formData.append("Mdd", state.model.Mdds.join("、"));
        // formData.append("Jj", state.model.Jj || "");
        // formData.append("Fm", state.model.Fm || "");
        // formData.append("Xq", editorDom.value?.state?.value);
        // formData.append("Xz", state.model.Xz || "");
        // console.log(state.model.Tps);
        // formData.append("Tps", state.model.Tps);

        // state.pics.forEach((file) => {
        //   formData.append(file.uid, file);
        // });
        shangpin_edit(state.model).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data);
            onLoadDetail();
          }
        });
      });
    };

    const onDelTp = (index) => {
      state.model.Tps.splice(index, 1);
      if (state.model.Fm) {
        if (state.model.Tps?.length > 0) {
          if (!state.model.Tps.includes(state.model.Fm)) {
            state.model.Fm = state.model.Tps[0];
          }
        } else {
          delete state.model.Fm;
        }
      }
    };

    //加载评价信息
    const loadPingJia = () => {
      if (!props.data?.id) return;
      shangpinpingjia_getbyspid(props.data.id).then((res) => {
        if (res.status == 200) {
          state.pjList = res.data || [];
          state.pjLoaded = true;
        }
      });
      shangpinpingjia_getsummary(props.data.id).then((res) => {
        if (res.status == 200) {
          state.pjSummary = res.data;
        }
      });
    };

    //获取指定星级百分比
    const getRatingPercent = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const total = state.pjSummary?.totalCount;
      if (!dist || !total) return 0;
      const map = {
        1: dist.one,
        2: dist.two,
        3: dist.three,
        4: dist.four,
        5: dist.five,
      };
      return Math.round(((map[star] || 0) / total) * 100);
    };

    //获取指定星级数量
    const getRatingCount = (star) => {
      const dist = state.pjSummary?.ratingDistribution;
      const map = {
        1: dist?.one,
        2: dist?.two,
        3: dist?.three,
        4: dist?.four,
        5: dist?.five,
      };
      return map[star] || 0;
    };

    //格式化时间
    const formatTime = (time) => {
      if (!time) return "";
      return new Date(time).toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    return {
      state,
      props,
      onLoadDetail,
      onMddFilter,
      onTabsChange,
      uploadDom,
      formDom,
      onUploadChange,
      onHandlePreview,
      onHandleRemove,
      onSubmit,
      editorDom,
      onDelTp,
      onLoadTc,
      pagedPjList,
      loadPingJia,
      getRatingPercent,
      getRatingCount,
      formatTime,
    };
  },
};
</script>
<style scoped lang="less">
.colorA2 {
  color: rgb(180, 180, 180);
}

.proUpBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  position: relative;

  .proUpShade {
    position: absolute;
    width: 100px;
    height: 100px;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    display: none;
  }

  &:hover .proUpShade {
    display: flex !important;
  }
}

.uploadAdd {
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
  border-radius: 5px;
  border: 1px dashed #e2e2e2;
  background-color: #f5f7fa;
  display: flex;
  color: #a2a2a2;

  &:hover {
    background-color: rgba(100, 100, 100, 0.2) !important;
    color: #fff !important;
  }
}

.uploadDel {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  color: #fff;
  display: none;
}

.uploadTp {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}

.uploadTpBox:hover .uploadDel {
  display: flex !important;
}

/* ===== 评价信息 ===== */
.pjWrap {
  padding: 10px 0;
}

.pjSummary {
  display: flex;
  gap: 40px;
  padding: 20px 24px;
  background: #fafbfc;
  border-radius: 8px;
  margin-bottom: 20px;
  align-items: center;
}

.pjScoreBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
}

.pjScore {
  font-size: 42px;
  font-weight: 700;
  color: #ff9900;
  line-height: 1;
}

.pjUnit {
  font-size: 18px;
  color: #999;
  margin-bottom: 6px;
}

.pjStars {
  margin: 4px 0;
}

.pjTotal {
  font-size: 13px;
  color: #999;
  margin-top: 4px;
}

.pjDist {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pjDistItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pjDistLabel {
  font-size: 13px;
  color: #666;
  width: 30px;
  text-align: right;
}

.pjDistCount {
  font-size: 13px;
  color: #999;
  width: 28px;
}

.pjList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pjItem {
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.pjHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.pjUser {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.pjTime {
  font-size: 12px;
  color: #bbb;
  margin-left: auto;
}

.pjTags {
  margin-bottom: 8px;
}

.pjContent {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin-bottom: 10px;
  white-space: pre-wrap;
  word-break: break-word;
}

.pjImages {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.pjImg {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.pjReply {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 8px;
}

.pjReplyHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.pjReplyLabel {
  font-size: 12px;
  font-weight: 600;
  color: #409eff;
}

.pjReplyTime {
  font-size: 12px;
  color: #bbb;
}

.pjReplyContent {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.pjPagination {
  display: flex;
  justify-content: center;
  padding: 12px 0;
}

.pjEmpty {
  padding: 40px 0;
}
</style>
